import React from 'react';

import "./Donate.css";





const DonateButton: React.FC = () => {



   return (

      <button className='button_don'>
  <div className="svg-1">
   
  </div>
  <p>Donate</p>
</button>
    

   );
}

export default DonateButton;
